import { render } from "./OfferSearchCriteria.vue?vue&type=template&id=2018ce64"
import script from "./OfferSearchCriteria.vue?vue&type=script&lang=js"
export * from "./OfferSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__